import { DsbcApiOptions } from '../_dsapi/DsbcApiOptions';
import { createDsbcApiUrl } from '../createDsbcApiUrl';
import { DsbcApi } from '../createDsbcRequest';
import { BaseRequest, BaseResponse } from '../shared';

interface invUserRankRequest extends BaseRequest {
  invId: string; //邀请活动ID
  rankNum: string; // 0-总榜，1-月榜，2-上月榜
}

export interface RankInvDataVO {
  cnt?: string; // 邀请人数 ,
  nick?: string; // 昵称 ,
  rank?: string; // 排名 ,
  reward?: string; // 奖品描述 ,
  uid?: string; // UID
}
export interface BulletinBaseRspVO {
  data?: RankInvDataVO[];
  numCnt?: string; //公示总条数，可能只能取到前100名数据，但是这个是实际总数 ,
  selfInfo?: RankInvDataVO;
  updateTime?: string; //公示更新时间
}

interface invUserRankResponse extends BaseResponse {
  Data: BulletinBaseRspVO;
}

/**
 * 个人性质邀请榜单
 * @param params
 * @returns
 */
export async function invUserRank(request: invUserRankRequest, options?: DsbcApiOptions) {
  const url = await createDsbcApiUrl('/inv/invUserRank');
  return DsbcApi.fetch<invUserRankResponse>(url, request, true, options);
}
